"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _wdh = require("@demant/wdh");

var _componentDataParser = _interopRequireDefault(require("./component-data-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ComponentBootstrap = /*#__PURE__*/function (_WDHComponent) {
  _inherits(ComponentBootstrap, _WDHComponent);

  function ComponentBootstrap(className) {
    var _this;

    var extraClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var componentScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'component';
    var schemaData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, ComponentBootstrap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComponentBootstrap).call(this, className + extraClassName));
    _this.name = className;
    _this.extraClassName = extraClassName;
    _this.componentScope = componentScope;
    _this.schemaData = schemaData;
    return _this;
  }

  _createClass(ComponentBootstrap, [{
    key: "init",
    value: function init(component) {
      var settings = new _componentDataParser["default"](component, this.name, this.schemaData).getComponentData();
      var selectedComponent = null;

      if (this.componentScope !== 'component') {
        // Many components scope, like header or footer
        selectedComponent = component.querySelector('.row');
      } else {
        // One component scope
        selectedComponent = component.querySelector('.component-content');
      }

      _reactDom["default"].render(_react["default"].createElement(this.reactApp, {
        settings: settings,
        $component: $(component)
      }), selectedComponent);
    }
  }]);

  return ComponentBootstrap;
}(_wdh.WDHComponent);

var _default = ComponentBootstrap;
exports["default"] = _default;